export default {"src":"/_next/static/media/logo.54b0062e.svg","height":46,"width":113,"blurWidth":0,"blurHeight":0};